<template>
  <div
    v-if="showHint"
    data-testid="pulse-mention-hint"
    class="
      tw-bg-sf-warning-subtle-2
      tw-text-sf-neutral-darker-1
      tw-p-2
      tw-text-xs
      tw-leading-4
      tw-w-full
    "
  >
    {{ hint }}
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import {
  scanMentionNames,
  isPulseWarningMention,
} from '@app/shared/vue/components/sf-markdown-editor/mentions'

interface Props {
  periodPrivate?: boolean
  periodName?: string
  text?: string
  pulseUsernames?: string[]
}

const props = withDefaults(defineProps<Props>(), {
  periodPrivate: false,
  periodName: '',
  text: '',
  pulseUsernames: () => [],
})

const emit =
  defineEmits<{
    (e: 'hint-visibility-changed', value: boolean): void
  }>()

const I18n = useI18n()

// Shares mention extraction/recipient logic with the editor so the banner and
// chips never disagree (see sf-markdown-editor/mentions).
const mentionsPulseRecipient = computed<boolean>(
  () =>
    !!props.text &&
    scanMentionNames(props.text).some((name) =>
      isPulseWarningMention(name, props.pulseUsernames, true)
    )
)

const showHint = computed<boolean>(
  () => props.periodPrivate && mentionsPulseRecipient.value
)

const hint = computed<string>(() =>
  I18n.t('communication.remark_form.pulse_mention_private_period', {
    period: props.periodName,
  })
)

watch(showHint, (value) => emit('hint-visibility-changed', value), {
  immediate: true,
})
</script>
